<template>
  <div>
    <Evtable
      :header="fields"
      :showSearch="false"
      :quickSearchKey="quickSearch.quickSearchKey"
      :quickSearchReg="quickSearch.quickSearchReg"
      :quickSearchPlaceholder="quickSearch.quickSearchPlaceholder"
      :tools="tools"
      :actions="action"
      actionWidth="100"
      url="/bigdata-exchange/monitor/exlog/page/2"
    ></Evtable>
  </div>
</template>

<script>
export default {
  data() {
    const that = this;
    return {
      pageload: true,
      search: "",
      //搜索栏
      quickSearch: {
        quickSearchKey: "search_LIKE_serverIp",
        quickSearchReg: /[%]|[_]|[*]/,
        quickSearchPlaceholder: "请输入服务器IP"
      },

      // 工具栏
      tools: [
        {
          name: "refresh" //刷新按钮
        }
      ],
      // 列表数据
      fields: [
        {
          label: "序号",
          type: "index"
        },
        {
          label: "IP",
          align: "center",
          prop: "serverIp"
          // width: "260"
        },
        {
          label: "数据库类型",
          align: "center",
          prop: "type",
          width: "110"
        },
        {
          label: "监听文件大小",
          align: "center",
          prop: "listenerFileSize",
          width: "200",
          formatter: function(h) {
            return h.listenerFileSize + "MB";
          }
        },
        {
          label: "CPU",
          align: "center",
          prop: "cpu",
          width: "120"
        },
        {
          label: "状态",
          align: "center",
          prop: "isFlag",
          width: "100",
          formatter: function(h) {
            let cpu = h.cpu.replace("%", "");
            if (cpu >= "85.0") {
              return "异常";
            } else if (h.ratio >= "0.9") {
              return "异常";
            } else if (h.listenerFileSize >= "2048") {
              return "异常";
            } else if (h.isFlag == "0") {
              return "正常";
            } else {
              return "异常";
            }
          }
        },
        {
          label: "最后监控时间",
          align: "center",
          prop: "createDate",
          width: "140"
        }
      ],
      datas: [],
      action: [
        {
          name: "databaseMonitor:s",
          icon: "fa-eye",
          click: function(e) {
            that.opt.editRow(
              e,
              that,
              "bigdata-exchange-monitor-databaseDetail",
              {
                id: e.logId
              }
            );
          }
        }
      ]
    };
  },
  methods: {},
  created: function() {
    this.request.oprahfun(this);
  }
};
</script>

<style scoped>
</style>
